import { Navigate } from "react-router-dom";
import { Button } from "@/components/ax/Button";
import { useI18n } from "@/i18n";

export function SessionGate({ session, guest, children }) {
  const { t } = useI18n();
  if (session.status === "guest") return guest ?? <Navigate to="/masuk" replace />;
  if (session.status === "unverified") return <Navigate to="/verifikasi-email" replace />;
  if (session.status === "consent") return <Navigate to="/onboarding" replace />;
  if (session.status === "ready") return <Fragment key={session.user.uid}>{children}</Fragment>;
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-4">
      {session.status === "error" ? <>
        <p role="alert" className="m-0 text-sm text-ax-text-2">{t("auth.session.failed")}</p>
        <Button onClick={session.retry}>{t("retry")}</Button>
      </> : <p role="status" className="m-0 text-sm text-ax-muted">{t("auth.checking")}</p>}
    </div>
  );
}
import { Fragment } from "react";
